export default __webpack_public_path__ + "static/media/warning--road-bump--g1.33610537.png";